import * as Scrivito from "scrivito"

export const PimContentWidget = Scrivito.provideWidgetClass(
  "PimContentWidget",
  {
    attributes: {
      name: "string",
      label: "string",
      text: "html"
    },
    extractTextAttributes: ["label", "text", "name"],
    onlyInside: ["PimData"]
  }
)
